import { render, staticRenderFns } from "./copy_right.vue?vue&type=template&id=1f844cf4"
import script from "./copy_right.vue?vue&type=script&lang=js"
export * from "./copy_right.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports